<template>
  <div>
    <div class="e-card" style="margin-top: 5px">
      <div
        class="e-card-content"
        style="display: grid; grid-template-columns: repeat(5, 1fr); column-gap: 2%"
      >
        <ejs-dropdownlist
          float-label-type="Always"
          :dataSource="applicationTypeDS"
          :fields="applicationTypeFields"
          placeholder="Application Type"
          v-model="applicationType"
        />
        <ejs-dropdownlist
          float-label-type="Always"
          :dataSource="invoiceTypeDS"
          :fields="invoiceTypeFields"
          placeholder="Invoice Type"
          v-model="selectedInvoiceType"
          @change="resetDateTypeDefault()"
        />
        <ejs-dropdownlist
          float-label-type="Always"
          :dataSource="dateTypeDS"
          :fields="dateTypeFields"
          placeholder="Date Type"
          v-model="dateType"
          :enabled="isClosedInvoiceType"
        />
        <ejs-daterangepicker
          float-label-type="Always"
          v-model="fromToDate"
          placeholder="Date From/To"
          format="dd/MM/yyyy"
        >
          <e-presets>
            <e-preset label="This Week"
            :start='weekStartDate' :end='weekEndDate'></e-preset>
            <e-preset label="Last Week"
            :start='lastWeekStartDate' :end='lastWeekEndDate'></e-preset>
            <e-preset label="This Month"
            :start='monthStartDate' :end='monthEndDate'></e-preset>
            <e-preset label="Last Month"
            :start='lastMonthStartDate' :end='lastMonthEndDate'></e-preset>
          </e-presets>
        </ejs-daterangepicker>
        <div style="width: 2%; padding-top: 4%">
          <ejs-button
            type="button"
            cssClass="e-danger"
            v-on:click.native="onOkButtonClick"
            :disabled="isButtonDisabled"
          >
            Ok
          </ejs-button>
        </div>
      </div>
    </div>
    <div style="margin-top: 5px">
      <ejs-grid
        ref="grid"
        :created="created"
        :dataSource="invoicesDS"
        :allowSorting="true"
        :allowPaging="true"
        :allowTextWrap="true"
        :pageSettings="pageSettings"
        :toolbar="toolbarOptions"
        :toolbarClick="toolbarClick"
        :allowExcelExport="true"
        :excelQueryCellInfo="excelQueryCellInfo"
        height="100%"
        width="100%"
      >
        <e-columns>
          <e-column field="invoiceNumber" headerText="Invoice #" textAlign="Left" width="140" />
          <e-column
            field="invoiceDate"
            headerText="Invoice Date"
            textAlign="center"
            width="140"
            type="date"
            :format="gridDateFormat"
          />
          <e-column
            field="totalAmount"
            headerText="Invoice Amount"
            textAlign="center"
            width="140"
            format="C2"
          />
          <e-column
            field="totalLevy"
            headerText="Levy Amount"
            textAlign="center"
            width="140"
            format="C2"
          />
          <e-column
            field="invoiceAmount"
            headerText="Total invoice"
            textAlign="center"
            width="140"
            format="C2"
          />
          <e-column
            field="invoiceStatus"
            headerText="Invoice Status"
            textAlign="Left"
            width="160"
          />
          <e-column field="paymentType" headerText="Payment Type" textAlign="Left" width="160" />
          <e-column
            field="requestType"
            headerText="Application Type"
            textAlign="Left"
            width="240"
          />
          <e-column field="RequestId" headerText="" textAlign="Left" width="0" />
          <e-column field="requestor" headerText="Applicant Name" textAlign="Left" width="160" />
          <e-column
            field="requestUserEmail"
            headerText="Applicant Email"
            textAlign="Left"
            width="200"
          />
          <e-column field="company" headerText="Applicant Company" textAlign="Left" width="200" />
          <e-column field="siteOwner" headerText="Site Owner" textAlign="Left" width="200" />
          <e-column field="siteId" headerText="Site Number" textAlign="Left" width="200" />
          <e-column field="siteAddress" headerText="Site Address" textAlign="Left" width="200" />
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>

<script>
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { DateRangePickerPlugin } from '@syncfusion/ej2-vue-calendars';

import Vue from 'vue';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
  ExcelExport,
} from '@syncfusion/ej2-vue-grids';
import { reportExportFileName } from '@/utils/report-utils';
import { getDataGridDateFormat, getExcelReportDate } from '../../../utils/date-utils';
import { applicationTypes, fetchInvoices } from '../services/usercredits-api';

Vue.use(DropDownListPlugin);
Vue.use(DateRangePickerPlugin);
Vue.use(GridPlugin);

class InvoiceType {
  constructor(name, label) {
    this.Name = name;
    this.Label = label;
  }
}
export default {
  name: 'AccountingReports',
  data() {
    // let year = new Date().getFullYear();
    // let month = new Date().getMonth();
    return {
      applicationType: '',
      applicationTypeDS: [{ id: 'all', appType: 'All' }],
      applicationTypeFields: { text: 'appType', value: 'id' },
      dateType: 'invoiceDate',
      dateTypeDS: [
        { id: 'invoiceDate', dateType: 'Invoice date' },
        { id: 'paymentDate', dateType: 'Transaction date' },
      ],
      dateTypeFields: { text: 'dateType', value: 'id' },
      fromToDate: null,
      selectedInvoiceType: 'Open',
      invoiceTypeDS: [
        new InvoiceType('open', 'Open Invoices'),
        new InvoiceType('closed', 'Closed Invoices'),
        new InvoiceType('Cancelled-WO', 'Write Off'),
      ],
      invoiceTypeFields: { text: 'Label', value: 'Name' },
      invoicesDS: null,
      toolbarOptions: ['Search', 'ExcelExport'],
      gridDateFormat: getDataGridDateFormat(),
      pageSettings: { pageSize: 15 },
      weekStartDate: new Date(
        // eslint-disable-next-line no-mixed-operators
        // eslint-disable-next-line no-mixed-operators, max-len
        new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() + 7) % 7)).toDateString(),
      ),
      weekEndDate: new Date(
        new Date(
          // eslint-disable-next-line no-mixed-operators
          // eslint-disable-next-line no-mixed-operators, max-len
          new Date().setDate(new Date(new Date().setDate((new Date().getDate() - (new Date().getDay() + 7) % 7))).getDate() + 6),
        ).toDateString(),
      ),
      lastWeekStartDate: new Date(
        // eslint-disable-next-line no-mixed-operators
        // eslint-disable-next-line no-mixed-operators, max-len
        new Date(new Date().setDate(new Date().getDate() - 7 - (new Date().getDay() + 7) % 7)).toDateString(),
      ),
      lastWeekEndDate: new Date(
        // eslint-disable-next-line no-mixed-operators, max-len
        new Date(new Date().setDate(new Date().getDate() - 1 - (new Date().getDay() + 7) % 7)).toDateString(),
      ),
      monthStartDate: new Date(
        new Date(new Date().setDate(1)).toDateString(),
      ),
      monthEndDate: new Date(
        // eslint-disable-next-line no-mixed-operators, max-len
        new Date(new Date(new Date().setMonth(new Date().getMonth() + 1)).setDate(0)).toDateString(),
      ),
      lastMonthStartDate: new Date(
        // eslint-disable-next-line no-mixed-operators, max-len
        new Date(new Date(new Date().setMonth(new Date().getMonth() - 1)).setDate(1)).toDateString(),
      ),
      lastMonthEndDate: new Date(
        new Date(new Date().setDate(0)).toDateString(),
      ),
      // lastYearStartDate : new Date(year - 1, 1, 1).toDateString(),
      // lastYearEndDate  :  new Date(year - 1, 11, 31).toDateString()
    };
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search, ExcelExport],
  },
  computed: {
    isButtonDisabled() {
      // eslint-disable-next-line no-mixed-operators, max-len
      return !this.dateType || !this.fromToDate || !this.applicationType || !this.selectedInvoiceType;
    },
    isOpenInvoiceType() {
      return (this.selectedInvoiceType === 'open');
    },
    isClosedInvoiceType() {
      return (this.selectedInvoiceType === 'closed' || this.selectedInvoiceType === 'Cancelled-WO');
    },
  },
  async created() {
    const appTypes = await applicationTypes();
    const typeList = appTypes.data.map((item) => item.category);
    [...new Set(typeList)].forEach((t) => this.applicationTypeDS.push({ id: t, appType: t }));
    // const typeList = appTypes.data.map(item => item.productName.trim());
    // [...new Set(typeList)].forEach((t) => this.applicationTypeDS.push({ id: t, appType: t }));
  },
  methods: {
    resetDateTypeDefault() {
      if (this.isOpenInvoiceType) {
        this.dateType = 'invoiceDate';
      }
    },
    created() {
      // Added clear button and its functionalities to Searchbar
      if (this.$refs.grid) {
        document
          .getElementById(`${this.$refs.grid.$el.id}_searchbar`)
          .addEventListener('keyup', (e) => {
            this.clearSearchEventListener(e, this.$refs.grid.$el.id);
          });
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove('e-search-icon');
      clearBtnEle.classList.add('e-clear-icon');

      clearBtnEle.addEventListener('click', () => {
        e.target.value = '';
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value === '') {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    async onOkButtonClick() {
      // Refactor: invStatuses are not used in this, so ui controller doesnt need to know
      // move out or make it globally available to avoid hard-coded strings hanging out everywhere
      const invoices = await fetchInvoices(
        this.dateType,
        this.fromToDate[0],
        this.fromToDate[1],
        this.applicationType,
        this.selectedInvoiceType,
      );
      this.invoicesDS = invoices ? invoices.data : [];
    },
    toolbarClick(args) {
      // eslint-disable-next-line default-case
      switch (args.item.text) {
        case 'Excel Export':
          this.$refs.grid.excelExport({
            fileName: reportExportFileName('Accounting Report.xlsx'),
          });
          break;
      }
    },
    excelQueryCellInfo(args) {
      // eslint-disable-next-line default-case
      switch (args.column.field) {
        case 'invoiceDate':
          // eslint-disable-next-line no-param-reassign
          args.value = getExcelReportDate(args.value);
          break;
      }
    },
  },
};
</script>
<style>
.e-input-group:not(.e-success):not(.e-warning):not(.e-error):not(.e-float-icon-left).e-disabled,
.e-input-group.e-float-icon-left:not(.e-success):not(.e-warning):not(.e-error).e-disabled
  .e-input-in-wrap,
.e-input-group
  .e-control-wrapper:not(.e-success):not(.e-warning):not(.e-error):not(.e-float-icon-left)
  .e-disabled,
.e-input-group.e-control-wrapper.e-float-icon-left:not(.e-success):not(.e-warning):not(.e-error)
  .e-disabled
  .e-input-in-wrap {
  border-bottom-color: black !important;
}
</style>
